import { Component } from '@angular/core';
import { AppConfig } from './app.config';
import { NavigationEnd, Router } from '@angular/router';
import { LogService } from './shared/_services/log.service';
import { OpenTelemetryService } from './shared/_services/open-telemetry.service';
import * as Sentry from '@sentry/angular';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	constructor(appConfig: AppConfig, router: Router, openTelemetryService: OpenTelemetryService, logService: LogService) {
		document.getElementsByTagName('title').item(0)!.innerText = appConfig.get('titoloApplicazione');
		router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				// Imposto i colori dell' applicazione
				const configurazioniTenant = JSON.parse(localStorage.getItem('configurazioni-tenant') || 'null');
				document.documentElement.style.setProperty(
					'--kd-main-color',
					configurazioniTenant?.colorePrimario || appConfig.get('colorePrimarioApplicazione') || '#0ea2f4',
				);
				document.documentElement.style.setProperty(
					'--kd-secondary-color',
					configurazioniTenant?.coloreSecondario || appConfig.get('coloreSecondarioApplicazione') || '#055480',
				);
			}
		});

		// Configurazione Sentry
		if (appConfig.get('sentryEnabled')) {
			Sentry.init({
				dsn: appConfig.get('sentryDsn'),
				integrations: [],
				release: `RELEASE_${appConfig.get('buildNumber')}`,
				environment: appConfig.get('environment'),
			});
		}

		// Inizializzo il servizio OpenTelemetry
		if (appConfig.get('openTelemetryEnabled')) {
			const openTelemetryOptions = {
				apiUrl: appConfig.get('openTelemetryApiUrl'),
				serviceName: appConfig.get('openTelemetryServiceName'),
				attributes: appConfig.get('openTelemetryAttributes') + appConfig.get('environment'),
				trace: true,
				log: true,
			};
			openTelemetryService.inizializza(openTelemetryOptions);
			openTelemetryService.attributiFissi.idUtente = JSON.parse(localStorage.getItem('alfresco-user') || '{}').id || '';
			openTelemetryService.abilitaLoggingPagineVisitate();
		}

		// Inizializzo il servizio di log
		logService.inizializza();
		// logService.abilitaLogOpenTelemetry('info');
	}
}
